<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" v-if="tariffData.code">Редактирование тарифа</h3>
        <h3 class="modal-title" v-else>Создание тарифа</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="tariffData" class="modal-body">
        <h5>Пресет</h5>
        <server-select
                  class="select-machines-orders-ingredients-create"
                  v-model="tariffPreset"
                  :custom-label="tariffName"
                  :endpoint="`billing/tariffs/presets/list`"
                />
        <div class="form-group mb-3" v-if="tariffData.id">
          <label>ID</label>
          <input
            type="text"
            class="form-control"
            v-validate="'required'"
            v-model="tariffData.id"
            data-vv-as="Название тарифа"
            disabled
          >
        </div>
        <div class="form-group mb-3">
          <label>Название тарифа</label>
          <input
            type="text"
            class="form-control"
            v-validate="'required'"
            v-model="tariffData.name"
            data-vv-as="Название тарифа"
          >
        </div>
        <div class="form-group mb-3">
          <label>Код тарифа <span class="text-success">(латиницей, маленькими буквами)</span></label>
          <input
            type="text"
            class="form-control"
            v-validate="'required'"
            v-model="tariffData.code"
            data-vv-as="Код тарифа"
            disabled
          >
        </div>
        <input-form-custom
          name="price"
          v-model="tariffData.price"
          label="Цена за модем"
          :rule="{ required: true, regex: /^[0-9]{1,6}([.][0-9]{1,2})?$/ }"
          class="mb-3"
          inputClass="form-control"
        />
        <div class="d-flex">
          <div class="custom-control custom-checkbox flex-grow-1">
            <input ref="receipt_checkbox" type="checkbox" class="custom-control-input" id="mobile_access-checkbox" v-model="tariffData.mobile_access">
            <label class="custom-control-label" for="mobile_access-checkbox">Мобильный доступ</label>
          </div>
        </div>
        <div class="d-flex">
          <div class="custom-control custom-checkbox flex-grow-1">
            <input ref="receipt_checkbox" type="checkbox" class="custom-control-input" id="active-checkbox" v-model="tariffData.active">
            <label class="custom-control-label" for="active-checkbox">Активность <span class="text-success">(если выключен, считается черновиком)</span></label>
          </div>
        </div>
        <div class="d-flex">
          <div class="custom-control custom-checkbox flex-grow-1">
            <input ref="receipt_checkbox" type="checkbox" class="custom-control-input" id="visible-checkbox" v-model="tariffData.visible">
            <label class="custom-control-label" for="visible-checkbox">Отображение <span class="text-success">(видимость клиентом)</span></label>
          </div>
        </div>
        <br>
        <div class="d-flex">
            <label style="width: 100%; text-align: center;">Список прав</label>
        </div>
      </div>
      <div class="alert alert-danger my-1" v-if="validationError">
        {{validationError}}
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <btn-action
          v-if="tariffData.code"
          class="btn btn-primary"
          @click="save"
        >Изменить тариф</btn-action>
        <btn-action
          v-else
          class="btn btn-primary"
          @click="save"
        >Создать тариф</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import filters from '../../filters'

  export default {
    props: ['id', 'tariff'],
    data () {
      return {
        tariffs: [],
        tariffPreset: { 
          "code": "empty", 
          "name": "Пустой", 
          "mobile_access": "отключён", 
          "active": "отключён", 
          "visible": "отключён", 
          "permissions": null, 
          "price": "0.00", 
          "notifications": null, 
          "statuses": null 
        },
        tariffData: {
            name: "Новый",
            code: "",
            price: "0.00",
            mobile_access: false,
            active: false,
            visible: false,
        },
        permissionslist: [],
        validationError: '',
        debug: {
          data: {},
        }
      }
    },
    watch: {
      tariffPreset: function (data) {
        // this.tariffData.name = data.name
        // this.tariffData.code = data.code
        this.tariffData.price = data.price

        this.tariffData.active = data.active
        this.tariffData.mobile_access = data.mobile_access
        this.tariffData.visible = data.visible

        this.permissionslist.data.data.forEach(permission => {
          if ( data.permissions.indexOf( permission.key ) != -1 ) {
            permission.active = true
          } else {
            permission.active = false
          }
        });
      },
    },
    methods: {
      tariffName (tariff) {
        return tariff.name + ' (' + tariff.code + ') [' + tariff.price + ' ₽]'
      },
      save () {
        return api.post('billing/tariffs/edit', {
            data: this.tariffData,
            permissions: this.permissionslist.data.data
          })
          .then(({data}) => {
              this.hide(false)
              window.alert(`Тариф успешно изменён`)
            })
          .catch(this.handleError)
      },
      hide (refresh = false) {
        this.$emit('hide', {
          refresh: refresh,
        })
      },
      handleError (error) {
        if (error.response && error.response.status === 422) {
          let obj = error.response.data.validation
          this.validationError = obj[Object.keys(obj)[0]][0]
        } else {
          throw error
        }
      },
    },
    mounted () {
      api.get('tariffs/preset/list')
      .then(data => {
          this.tariffs = data.data.data

        api.get('permissionslist?per_page=all')
        .then(data => {

            this.tariffData.id = this.tariff.id
            this.tariffData.name = this.tariff.name
            this.tariffData.code = this.tariff.code
            this.tariffData.price = this.tariff.price

            this.tariffData.active = this.tariff.active
            this.tariffData.mobile_access = this.tariff.mobile_access
            this.tariffData.visible = this.tariff.visible

            data.data.data.forEach(permission => {
              if ( this.tariff.permissions.indexOf( permission.key ) != -1 ) {
                permission.active = true
              }
            });
            
            this.permissionslist = data
        })
      })
      // api.get('tariffs/get')
      // .then(data => {
      //   console.log(data)
      //   this.debug.data = data
      //     // this.tariffs = data.data.data
      // })
    },
    asyncComputed: {
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/billing/modals/tariff-edit.vue